<template>
  <div>
    <v-container fluid>
      <v-layout justify-center row>
        <v-flex xs12 sm8>
          <v-card>
            <v-layout justify-center row>
              <v-flex xs11>
                <v-card-title class="pb-0 font-weight-light display-1 ">
                  <p class="text-xs-center mx-auto">
                    DATOS DE LA RESERVA
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <p class="body-1 font-weight-light text-xs-center">Número de file {{ data.resumen.file }}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="body-1 font-weight-light text-xs-center mb-0">Facturado a {{ data.agencia.nombre }}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="body-1 font-weight-light text-xs-center mb-0">Usuario {{ data.usuario.usuario }}</p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-text v-for="(cupo, indexc) in data.resumen.cupos" :key="'cupoI' + indexc">
                  <v-divider class="mt-0"></v-divider>
                  <p class="title font-weight-light text-uppercase text-xs-center">
                    {{ cupo.descripcion }}
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon color="green" dark v-on="on" small class="fix-line">check_circle</v-icon>
                      </template>
                      <span>Confirmado</span>
                    </v-tooltip>
                  </p>
                  <ResumenItinerario :resumen="cupo.ida" :idxcupo="'ida'" />
                  <ResumenItinerario :resumen="cupo.vuelta" :idxcupo="'vuelta'" />
                  <v-list subheader>
                    <v-subheader>Pasajeros</v-subheader>

                    <v-list-tile v-for="(p, indexpc) in cupo.pasajeros" :key="indexpc">
                      <v-list-tile-content>
                        <v-list-tile-title class="caption"> {{ p.apellido }} {{ p.nombre }} </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
                <v-card-text
                  class="pa-0"
                  xs12
                  sm8
                  v-for="(hotel, indexht) in toArray(data.resumen.hoteles.hotel)"
                  :key="`car-${indexht}`"
                >
                  <v-divider class="mt-0"></v-divider>
                  <TituloInfoHotel
                    :in="hotel.in | formatDMY"
                    :out="hotel.out | formatDMY"
                    :diff="_$diffDias(hotel.in, hotel.out)"
                    :nombre="hotel.nombre"
                  >
                  </TituloInfoHotel>
                  <div v-for="(hab, indexhab) in toArray(hotel.habitaciones.habitacion)" :key="'hab' + indexhab">
                    <p class="body-1 font-weight-light text-xs-center mb-0">
                      {{ hab.nombre.toUpperCase() }}
                      <v-tooltip bottom v-if="hab.status == 1">
                        <template v-slot:activator="{ on }">
                          <v-icon color="green" dark v-on="on" small>check_circle</v-icon>
                        </template>
                        <span>Confirmado</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else-if="hab.status == 5">
                        <template v-slot:activator="{ on }">
                          <v-icon color="orange" dark v-on="on" small>fas fa-exclamation-circle</v-icon>
                        </template>
                        <span>A confirmar</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on }">
                          <v-icon color="green" dark v-on="on" small>fas fa-exclamation-circle</v-icon>
                        </template>
                        <span>Desconocido</span>
                      </v-tooltip>
                    </p>
                    <table class="table table-borderless text-center my-2">
                      <thead>
                        <tr>
                          <th scope="col" class="py-0">
                            <p class="caption font-weight-regular">
                              Régimen
                            </p>
                          </th>
                          <th scope="col" class="py-0" v-if="hab.promocion">
                            <p class="caption font-weight-regular">
                              Promoción
                            </p>
                          </th>
                          <th scope="col" class="py-0" v-if="hab.cancelacionPenalidad">
                            <p class="caption font-weight-regular">
                              Límite de cancelación
                            </p>
                          </th>
                          <th scope="col" class="py-0" v-if="hab.plan">
                            <p class="caption font-weight-regular">
                              Comida
                            </p>
                          </th>
                          <th scope="col" class="py-0" v-if="hab.tkt">
                            <p class="caption font-weight-regular">Ticket {{ hab.tkt.in | formatDMY }}</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="py-0">
                            <p class="caption">
                              {{ hab.regimenDescripcion == undefined ? hab.regimen : hab.regimenDescripcion }}
                            </p>
                          </td>
                          <td class="py-0" v-if="hab.promocion">
                            <p class="caption">
                              {{ hab.promocion }}
                            </p>
                          </td>
                          <td class="py-0" v-if="hab.cancelacionPenalidad">
                            <p class="caption">
                              {{
                                hab.cancelacionPenalidad.absoluteDeadline == undefined
                                  ? hab.cancelacionPenalidad.end
                                  : hab.cancelacionPenalidad.absoluteDeadline | formatDMY
                              }}
                            </p>
                          </td>
                          <td class="py-0" v-if="hab.plan">
                            <p class="caption">
                              {{ hab.plan.nombre }}
                            </p>
                          </td>
                          <td class="py-0" v-if="hab.tkt">
                            <p class="caption">
                              {{ hab.tkt.nombre }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <v-list subheader v-if="hab.tkts">
                      <v-subheader>Pases</v-subheader>

                      <v-list-tile v-for="(tk, indexph) in toArray(hab.tkts.tkt)" :key="'tkts-' + indexph">
                        <v-list-tile-content>
                          <v-list-tile-title class="caption">
                            {{ tk.nombre }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                    <v-list subheader>
                      <v-subheader>Pasajeros</v-subheader>

                      <v-list-tile v-for="(p, indexph) in toArray(hab.rooming.pasajero)" :key="'pax' + indexph">
                        <v-list-tile-content>
                          <v-list-tile-title class="caption"> {{ p.apellido }} {{ p.nombre }} </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </div>
                </v-card-text>
                <v-card-text>
                  <v-flex xs12>
                    <v-layout justify-center row>
                      <v-flex xs11 v-for="(t, tindx) in data.resumen.traslados" :key="tindx">
                        <p class="body-1 font-weight-light text-xs-center">
                          {{ t.tipo.toUpperCase() }}
                          {{ t.nombre.toUpperCase() }}
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon color="green" dark v-on="on" small>check_circle</v-icon>
                            </template>
                            <span>Confirmado</span>
                          </v-tooltip>
                        </p>
                        <table class="table table-borderless text-center my-2 ">
                          <thead>
                            <tr>
                              <th scope="col" class="py-0" v-if="t.direccion == 'X' || t.direccion == 'I'">
                                <p class="caption font-weight-regular">
                                  Llegada
                                </p>
                              </th>
                              <th scope="col" class="py-0" v-if="t.direccion == 'X' || t.direccion == 'I'">
                                <p class="caption font-weight-regular">
                                  Número de vuelo de llegada
                                </p>
                              </th>
                              <th scope="col" class="py-0" v-if="t.direccion == 'X' || t.direccion == 'O'">
                                <p class="caption font-weight-regular">
                                  Salida
                                </p>
                              </th>
                              <th scope="col" class="py-0" v-if="t.direccion == 'X' || t.direccion == 'O'">
                                <p class="caption font-weight-regular">
                                  Número de vuelo de salida
                                </p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="py-0" v-if="t.direccion == 'X' || t.direccion == 'I'">
                                <p class="caption">
                                  {{ t.in | formatDMY }}
                                </p>
                              </td>
                              <td class="py-0" v-if="t.direccion == 'X' || t.direccion == 'I'">
                                <p class="caption">
                                  {{ t.nroVueloLlegada }}
                                </p>
                              </td>
                              <td class="py-0" v-if="t.direccion == 'X' || t.direccion == 'O'">
                                <p class="caption">
                                  {{ t.out | formatDMY }}
                                </p>
                              </td>
                              <td class="py-0" v-if="t.direccion == 'X' || t.direccion == 'O'">
                                <p class="caption">
                                  {{ t.nroVueloSalida }}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
                <v-card-text>
                  <v-divider class="mt-0"></v-divider>
                  <v-layout justify-center row>
                    <v-flex xs12 v-for="(t, tkindx) in data.resumen.tickets" :key="`t-${tkindx}`">
                      <p class="title font-weight-light text-xs-center mb-0">
                        {{ t.nombre }}
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon color="green" dark v-on="on" small class="fix-line">check_circle</v-icon>
                          </template>
                          <span>Confirmado</span>
                        </v-tooltip>
                      </p>
                      <p class="font-weight-light mb-0 caption text-xs-center">
                        {{ t.in | formatDMY }}
                      </p>
                      <v-list subheader>
                        <v-subheader>Pasajeros</v-subheader>

                        <v-list-tile v-for="(p, indexph) in toArray(t.rooming.pax)" :key="'pax' + indexph">
                          <v-list-tile-content>
                            <v-list-tile-title class="caption"> {{ p.apellido }} {{ p.nombre }} </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-flex>
              <v-flex xs11>
                <v-divider class="mt-0"></v-divider>
                <p class="text-xs-right display-1">
                  Total: {{ data.resumen.tarifa.moneda }}
                  {{ data.resumen.tarifa.total }}
                </p>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import ResumenItinerario from "@/components/cupos/ResumenItinerario.vue"
import TituloInfoHotel from "@/components/utiles/TituloInfoHotel.vue"
export default {
  name: "resumen",
  props: ["data"],
  components: {
    ResumenItinerario,
    TituloInfoHotel
  },
  created() {},
  mounted() {},
  methods: {},
  data: function() {
    return {}
  }
}
</script>
<style scoped>
.fix-line {
  line-height: 1.5;
}
</style>
